// import { getRedirectUrl } from '../apis/api_common';
import Vue from 'vue';

const state = {

    onload: false,

    loading: false,
    
    routeLoading: false,

    transitionName: 'slide-left',

    modal: { 
        open: false, 
        title: null, 
        content: null, 
        btnClose: null, 

        btnOne: null,
        btnOneSubmit: null,

        btnTwo: null,
        btnTwoSubmit: null,
    },




};

const getters = {};

const mutations = {

    SHOW_ONLOAD() {
        Vue.prototype.$Progress.finish();
        setTimeout(() => {
            state.onload = true; 
        }, 200);
    },
    HIDE_ONLOAD() {
        Vue.prototype.$Progress.start();
        state.onload = false;
    },
    START_LOADING(state) {
        state.loading = true;
    },
    
    END_LOADING(state) {
        state.loading = false;
    },
    START_ROUTE_LOADING(state) {
        state.routeLoading = true;
    },

    SET_TRANSITION_NAME_SLIDE_LEFT(state) {
        setTimeout(() => {
            state.transitionName = 'slide-left';
        }, 1000);
    },
    
    SET_TRANSITION_NAME_SLIDE_RIGHT(state) {
        state.transitionName = 'slide-right';
    },
    
    END_ROUTE_LOADING(state) {
        // state.routeLoading = false;
        setTimeout(() => {
            state.routeLoading = false;
        }, 200);
        
    },

    CLOSE_MODAL(state) {
        state.modal.open = false;
    },

    CLEAR_MODAL(state) {
        state.modal.open = false;
        state.modal.title = null;
        state.modal.content = null;
        state.modal.submit = null;
    },

    OPEN_MODAL(state, { title, content, btnOne, btnTwo, btnOneSubmit , btnTwoSubmit }) {
        state.modal.title = title ? title : null;
        state.modal.content = content ? content : null;

        state.modal.btnOne = btnOne ? btnOne : null;
        state.modal.btnOneSubmit = btnOneSubmit ? btnOneSubmit : null;

        state.modal.btnTwo = btnTwo ? btnTwo : null;
        state.modal.btnTwoSubmit = btnTwoSubmit ? btnTwoSubmit : null;

        state.modal.open = true;
    },

};

const actions = {
    // async GET_CONNECT_REDIRECT_URL() {
    //     try {
    //         const response = await getRedirectUrl();
    //         return response.data.data;
    //     } catch (e) {
    //         return Promise.reject(e);
    //     }
    // },
};

export default {mutations, state, actions, getters};